import { Component, EventEmitter, Inject, inject, OnInit, Output } from "@angular/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { MatInput } from "@angular/material/input";
import { MatIcon } from "@angular/material/icon";
import { MultiFactorService } from "../../../../../../../shared/src/lib/services/multi-factor.service";
import { ApiService } from "../../../../../../../shared/src";
import { DomainService } from "../../../../../../../shared/src/lib/services/domain.service";
import { environment } from "../../../../../../../shared/src/environments/environment";
import { SnackbarService } from "../../../../../../../shared/src/lib/services/snackbar.service";
import { MAT_DIALOG_DATA, MatDialogClose } from "@angular/material/dialog";
import { QRCodeComponent } from "angularx-qrcode";

@Component({
  selector: "app-mfa-setup",
  imports: [MatFormFieldModule, ReactiveFormsModule, TranslateModule, MatInput, MatIcon, MatDialogClose, QRCodeComponent],
  templateUrl: "./mfa-setup.component.html",
  styleUrl: "./mfa-setup.component.scss",
})
export class MfaSetupComponent implements OnInit {
  @Output() onContinue: EventEmitter<any> = new EventEmitter<any>();
  mfaService = inject(MultiFactorService);
  apiService = inject(ApiService);
  domainService = inject(DomainService);
  snackbar = inject(SnackbarService);
  setupData: any = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    this.setupMfa();
  }

  get userId() {
    return this.data?.user?.ID;
  }

  setupMfa() {
    if (!this.userId) return;
    const params = {
      user_id: this.userId,
      issuer: this.domainService.getDomain(),
      site: environment.sURL,
    };
    this.mfaService.setupMfaAuth(params).subscribe((response: any) => {
      if (response) this.setupData = response;
    });
  }

  handleCopy(secret: string) {
    navigator.clipboard
      .writeText(secret)
      .then(() => {
        this.snackbar.openSnackbar({ message: "Setup key copied to clipboard!" });
      })
      .catch((err) => {
        console.error("Failed to copy IDs:", err);
      });
  }
}
